import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';

const CustomFormSelect = ({ register, dirtyFields, fieldName, errorMessage, readOnly, options, skipNull, onChange, isMulti }) => {

  const { t } = useTranslation();

  // determine which css classes we'll apply to this field
  const inputClasses = []
  if (errorMessage)
    inputClasses.push('is-invalid')
  else if (dirtyFields && dirtyFields[fieldName])
    inputClasses.push('is-valid')

  if (readOnly)
    inputClasses.push('form-control-plaintext')
  else if (! isMulti)
    inputClasses.push('form-select')


  if (isMulti)
    return <Select
      data-testid={"fld" + fieldName}
      isMulti={true}
      isDisabled={readOnly}
      className={inputClasses.join(' ')}
      {...register(fieldName)}
      readOnly={readOnly}
      options={options}
      aria-invalid={errorMessage ? "true" : "false"}
      />

  return (
    <>
      <select className={inputClasses.join(' ')}
        data-testid={"fld" + fieldName}
        {...register(fieldName)}
        readOnly={readOnly}
        disabled={readOnly}
        aria-invalid={errorMessage ? "true" : "false"}
        // onChange={onChange}
      >
        {!skipNull ?
          <option key="" value=""></option>
          : null}
        {options?.map(option => (
          <option key={option.id} value={option.id}>{option.valueKey ? t(option.valueKey) : option.value}</option>
        ))}
      </select>

      {errorMessage && <p role="alert">{errorMessage}</p>}
    </>
  );
};

CustomFormSelect.propTypes = {
  fieldName: PropTypes.string.isRequired,  // name of the field
  dirtyFields: PropTypes.object,            // an array of which fields in the form are considered 'dirty'
  errorMessage: PropTypes.string,          // an error message if this field is failing validation
  register: PropTypes.func.isRequired      // used by react-hook-form 
};

export default CustomFormSelect;
